export interface PaymentSystem {
   id: number;
   name: string;
   key: PaymentSystemKey;
   active: boolean;
   payment_system_reference: string | null;
   updated_at: string;
}

export enum PaymentSystemKey {
   EasyPay = 'easypay',
   ETM = 'etm',
}
